"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisClientObserver = exports.NotifyRemoteType = exports.NotifyType = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const BaseType_1 = require("../base/BaseType");
const IrisTrackEventHandler_1 = require("../event_handler/IrisTrackEventHandler");
const util_1 = require("../util");
var NotifyType;
(function (NotifyType) {
    NotifyType[NotifyType["PUBLISH_TRACK"] = 0] = "PUBLISH_TRACK";
    NotifyType[NotifyType["UNPUBLISH_TRACK"] = 1] = "UNPUBLISH_TRACK";
    NotifyType[NotifyType["MUTE_TRACK"] = 2] = "MUTE_TRACK";
    NotifyType[NotifyType["UNMUTE_TRACK"] = 3] = "UNMUTE_TRACK";
    NotifyType[NotifyType["REMOVE_TRACK"] = 4] = "REMOVE_TRACK";
})(NotifyType || (exports.NotifyType = NotifyType = {}));
var NotifyRemoteType;
(function (NotifyRemoteType) {
    NotifyRemoteType[NotifyRemoteType["SUBSCRIBE_VIDEO_TRACK"] = 0] = "SUBSCRIBE_VIDEO_TRACK";
    NotifyRemoteType[NotifyRemoteType["SUBSCRIBE_AUDIO_TRACK"] = 1] = "SUBSCRIBE_AUDIO_TRACK";
    NotifyRemoteType[NotifyRemoteType["UNSUBSCRIBE_VIDEO_TRACK"] = 2] = "UNSUBSCRIBE_VIDEO_TRACK";
    NotifyRemoteType[NotifyRemoteType["UNSUBSCRIBE_AUDIO_TRACK"] = 3] = "UNSUBSCRIBE_AUDIO_TRACK";
})(NotifyRemoteType || (exports.NotifyRemoteType = NotifyRemoteType = {}));
class IrisClientObserver {
    constructor(engine) {
        this.audioTrackPackageObservers = [];
        this.videoTrackPackageObservers = [];
        this.remoteUserPackageObservers = [];
        this._engine = engine;
    }
    addAudioTrackPackageObserver(observer) {
        this.audioTrackPackageObservers.push(observer);
    }
    addVideoTrackPackageObserver(observer) {
        this.videoTrackPackageObservers.push(observer);
    }
    addRemoteUserPackageObserver(observer) {
        this.remoteUserPackageObservers.push(observer);
    }
    removeRemoteUserPackageObserver(observer) {
        this.remoteUserPackageObservers = this.remoteUserPackageObservers.filter((item) => item !== observer);
    }
    removeAudioTrackPackageObserver(observer) {
        this.audioTrackPackageObservers = this.audioTrackPackageObservers.filter((item) => item !== observer);
    }
    removeVideoTrackPackageObserver(observer) {
        this.videoTrackPackageObservers = this.videoTrackPackageObservers.filter((item) => item !== observer);
    }
    publishTrack(trackPackage, irisClientList) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const globalState = this._engine.globalState;
            if (!trackPackage.track)
                return;
            let track = trackPackage.track;
            for (const irisClient of irisClientList) {
                let needPublish = false;
                const options = irisClient.irisClientState;
                if (globalState.enabledAudio && globalState.enabledLocalAudio) {
                    switch (trackPackage.type) {
                        case BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophonePrimary:
                        case BaseType_1.IrisAudioSourceType.kAudioSourceTypeMicrophoneSecondary:
                            if (options.publishMicrophoneTrack) {
                                this._engine.trackHelper.setMuted(track, false);
                                needPublish = true;
                            }
                            break;
                        case BaseType_1.IrisAudioSourceType.kAudioSourceTypeScreenCapture:
                            if (options.publishScreenCaptureAudio) {
                                needPublish = true;
                            }
                            break;
                        case BaseType_1.IrisAudioSourceType.kAudioSourceTypeBufferSourceAudio:
                            needPublish = true;
                            break;
                    }
                    if (needPublish) {
                        irisClient.addLocalAudioTrack(trackPackage);
                    }
                }
                if (globalState.enabledVideo && globalState.enabledLocalVideo) {
                    switch (trackPackage.type) {
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_PRIMARY:
                            if (options.publishScreenTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_SECONDARY:
                            if (options.publishSecondaryScreenTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_THIRD:
                            if (options.publishThirdScreenTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_SCREEN_FOURTH:
                            if (options.publishFourthScreenTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY:
                            if (options.publishCameraTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_SECONDARY:
                            if (options.publishSecondaryCameraTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_THIRD:
                            if (options.publishThirdCameraTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_FOURTH:
                            if (options.publishFourthCameraTrack) {
                                needPublish = true;
                            }
                            break;
                        case NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CUSTOM:
                            if (options.publishCustomVideoTrack) {
                                needPublish = true;
                            }
                            break;
                    }
                    if (needPublish) {
                        irisClient.setLocalVideoTrack(trackPackage);
                    }
                }
                if (needPublish &&
                    ((_a = irisClient.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.channelName) &&
                    !((_b = irisClient.agoraRTCClient.localTracks) === null || _b === void 0 ? void 0 : _b.includes(track))) {
                    try {
                        util_1.AgoraConsole.debug(`publishTrack ${track}`);
                        yield irisClient.agoraRTCClient.publish(track);
                    }
                    catch (reason) {
                        // AUDIT-v18: formato error con contesto (trackType + channelId)
                        // per diagnosi. In long-session publish può fallire per CONNECTION_LOST
                        // transiente; meglio avere traccia.
                        const ch = (_d = (_c = irisClient.agoraRTCClient) === null || _c === void 0 ? void 0 : _c.channelName) !== null && _d !== void 0 ? _d : 'n/a';
                        util_1.AgoraConsole.error(`publishTrack failed (ch=${ch}, type=${trackPackage.type}): ${reason}`);
                    }
                }
            }
        });
    }
    unpublishTrack(trackPackage) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!trackPackage.track) {
                return;
            }
            let irisClient = trackPackage.irisClient;
            let track = trackPackage.track;
            if (!irisClient) {
                return;
            }
            let agoraRTCClient = irisClient.agoraRTCClient;
            if ((_a = agoraRTCClient === null || agoraRTCClient === void 0 ? void 0 : agoraRTCClient.localTracks) === null || _a === void 0 ? void 0 : _a.includes(track)) {
                util_1.AgoraConsole.debug(`unpublishTrack ${track}`);
                yield this._engine.clientHelper.unpublish(agoraRTCClient, track);
            }
        });
    }
    muteTrack(trackPackage) {
        return __awaiter(this, void 0, void 0, function* () {
            let track = trackPackage.track;
            util_1.AgoraConsole.debug(`muteTrack ${track}`);
            if (!(track === null || track === void 0 ? void 0 : track.muted)) {
                yield this._engine.trackHelper.setMuted(trackPackage.track, true);
            }
        });
    }
    unmuteTrack(trackPackage) {
        return __awaiter(this, void 0, void 0, function* () {
            let track = trackPackage.track;
            util_1.AgoraConsole.debug(`unmuteTrack ${track}`);
            if (track === null || track === void 0 ? void 0 : track.muted) {
                yield this._engine.trackHelper.setMuted(trackPackage.track, false);
            }
        });
    }
    removeTrack(trackPackage) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let irisClientManager = this._engine.irisClientManager;
            try {
                if (!trackPackage.track) {
                    return;
                }
                util_1.AgoraConsole.debug(`removeTrack ${trackPackage.track}`);
                let irisClient = trackPackage.irisClient;
                if (!irisClient) {
                    // Fix screen-share race: per gli screen capture track, trackPackage.irisClient
                    // viene settato solo dopo che updateChannelMediaOptionsEx(publishScreenCaptureVideo:true)
                    // è stato processato (publishTrack → setLocalVideoTrack sul secondary).
                    // Se stopScreenCapture arriva prima (toggle rapido o errore nel setup),
                    // irisClient è undefined e il vecchio fallback a irisClientList[0] (main)
                    // causava clearLocalVideoTrack sul MAIN, distruggendo la CameraVideoTrack
                    // del main. Preferiamo trovare il client corretto cercando un secondary
                    // che contenga proprio questo trackPackage, altrimenti un secondary attivo.
                    // Ultimissimo fallback: main (solo se nessun secondary esiste).
                    let match = irisClientManager.irisClientList.find((c) => c.videoTrackPackage === trackPackage);
                    if (!match) {
                        match = irisClientManager.irisClientList
                            .slice(1)
                            .find((c) => c.connection != null);
                    }
                    irisClient = match !== null && match !== void 0 ? match : irisClientManager.irisClientList[0];
                }
                this.unpublishTrack(trackPackage);
                if (this._engine.implHelper.isAudio(trackPackage.type)) {
                    yield irisClientManager.processAudioTrackClose(trackPackage);
                    this._engine.rtcEngineEventHandler.onLocalAudioStateChanged_f33d789(NATIVE_RTC.LOCAL_AUDIO_STREAM_STATE.LOCAL_AUDIO_STREAM_STATE_STOPPED, 0);
                    this._engine.rtcEngineEventHandler.onLocalAudioStateChanged_13b6c02({
                        localUid: (_a = irisClient.agoraRTCClient) === null || _a === void 0 ? void 0 : _a.uid,
                        channelId: (_b = irisClient.agoraRTCClient) === null || _b === void 0 ? void 0 : _b.channelName,
                    }, NATIVE_RTC.LOCAL_AUDIO_STREAM_STATE.LOCAL_AUDIO_STREAM_STATE_STOPPED, 0);
                    irisClientManager.removeLocalAudioTrackPackage(trackPackage);
                    irisClient.removeLocalAudioTrack(trackPackage);
                }
                else if (BaseType_1.IrisAudioSourceType.kAudioSourceTypeBufferSourceAudio ===
                    trackPackage.type) {
                    yield irisClientManager.processBufferSourceAudioTrackClose(trackPackage);
                    irisClient.removeLocalAudioTrack(trackPackage);
                    irisClientManager.removeLocalAudioTrackPackage(trackPackage);
                }
                else if (this._engine.implHelper.isVideoCamera(trackPackage.type)) {
                    yield irisClientManager.processVideoTrackClose(trackPackage);
                }
                else if (this._engine.implHelper.isScreenCapture(trackPackage.type)) {
                    yield irisClientManager.processVideoTrackClose(trackPackage);
                    this._engine.rtcEngineEventHandler.onLocalVideoStateChanged_a44228a(trackPackage.type, NATIVE_RTC.LOCAL_VIDEO_STREAM_STATE.LOCAL_VIDEO_STREAM_STATE_STOPPED, 0);
                    irisClientManager.removeLocalVideoTrackPackage(trackPackage);
                    // Safety: clearLocalVideoTrack solo se videoTrackPackage del client è
                    // ESATTAMENTE questo pkg. Se il resolve sopra è caduto su un main (fallback
                    // ultimo), il main ha come videoTrackPackage la sua camera, non lo screen
                    // → il check qui previene destruction della camera main durante
                    // stopScreenCapture in race.
                    if (irisClient.videoTrackPackage === trackPackage) {
                        irisClient.clearLocalVideoTrack();
                    }
                }
            }
            catch (reason) {
                util_1.AgoraConsole.error(reason);
                throw reason;
            }
        });
    }
    notifyLocal(type, scopePackages, irisClientList) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let scopePackage of scopePackages) {
                switch (type) {
                    case NotifyType.PUBLISH_TRACK:
                        if (scopePackage) {
                            yield this.publishTrack(scopePackage, irisClientList !== null && irisClientList !== void 0 ? irisClientList : this._engine.irisClientManager.irisClientList);
                        }
                        break;
                    case NotifyType.MUTE_TRACK:
                        if (scopePackage) {
                            yield this.muteTrack(scopePackage);
                        }
                        break;
                    case NotifyType.UNMUTE_TRACK:
                        if (scopePackage) {
                            yield this.unmuteTrack(scopePackage);
                        }
                        break;
                    case NotifyType.UNPUBLISH_TRACK:
                        if (scopePackage) {
                            yield this.unpublishTrack(scopePackage);
                        }
                        break;
                    case NotifyType.REMOVE_TRACK:
                        if (scopePackage) {
                            yield this.removeTrack(scopePackage);
                        }
                        break;
                }
            }
        });
    }
    subscribeVideoTrack(userPackage, force) {
        return __awaiter(this, void 0, void 0, function* () {
            // AUDIT-v18: pkg null guard (può arrivare undefined da notifyRemote).
            if (!userPackage)
                return;
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(userPackage.connection);
            if (!irisClient) {
                return;
            }
            let autoSubscribeVideo = irisClient.irisClientState.autoSubscribeVideo;
            let needSubscribe = autoSubscribeVideo || force;
            let enableVideo = this._engine.globalState.enabledVideo;
            if (enableVideo && needSubscribe && irisClient.agoraRTCClient) {
                // Fix user-account mode: in Agora Web SDK v4, remoteUser.uid is the string
                // userAccount after joinChannelWithUserAccount. userPackage.uid is numeric
                // (_uintid assigned by server). Match both cases via getUidFromRemoteUser.
                let user = irisClient.agoraRTCClient.remoteUsers.find((item) => (0, util_1.getUidFromRemoteUser)(item) === userPackage.uid);
                if (!user || !user.hasVideo) {
                    return;
                }
                yield irisClient.agoraRTCClient.subscribe(user, 'video').then(() => {
                    util_1.AgoraConsole.debug('onEventUserPublished subscribe video success');
                    // setup video maybe called before subscribe, so we need to play video here too
                    if (userPackage.element) {
                        this._engine.trackHelper.play(user.videoTrack, userPackage.element, userPackage.videoPlayerConfig);
                    }
                    let param = {
                        client: irisClient.agoraRTCClient,
                        remoteUser: user,
                        track: user.videoTrack,
                        trackType: 'IRemoteVideoTrack',
                        videoSourceType: userPackage.videoSourceType,
                    };
                    let trackEventHandler = new IrisTrackEventHandler_1.IrisTrackEventHandler(param, this._engine);
                    this._engine.irisClientManager.addTrackEventHandler(trackEventHandler);
                }).catch((e) => {
                    // P1.7: errore subscribe video lato peer — remote resta nero senza
                    // diagnostic. Log esplicito per debug.
                    util_1.AgoraConsole.error(`subscribe video failed for uid=${userPackage.uid}: ${e}`);
                });
            }
        });
    }
    subscribeAudioTrack(userPackage, force) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!userPackage)
                return;
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(userPackage.connection);
            if (!irisClient) {
                return;
            }
            let autoSubscribeAudio = irisClient.irisClientState.autoSubscribeAudio;
            let needSubscribe = autoSubscribeAudio || force;
            let enableAudio = this._engine.globalState.enabledAudio;
            if (enableAudio && needSubscribe && irisClient.agoraRTCClient) {
                // Fix user-account mode: see note in subscribeVideoTrack. Prior to this
                // patch the comparison always failed in user-account mode, so remote
                // audio was never subscribed and remained silent even after the peer
                // toggled their mic on.
                let user = irisClient.agoraRTCClient.remoteUsers.find((item) => (0, util_1.getUidFromRemoteUser)(item) === userPackage.uid);
                if (!user || !user.hasAudio) {
                    return;
                }
                yield irisClient.agoraRTCClient.subscribe(user, 'audio').then(() => {
                    util_1.AgoraConsole.debug('onEventUserPublished subscribe audio success');
                    this._engine.trackHelper.play(user.audioTrack);
                    let param = {
                        client: irisClient.agoraRTCClient,
                        remoteUser: user,
                        track: user.audioTrack,
                        trackType: 'IRemoteTrack',
                        videoSourceType: userPackage.videoSourceType,
                    };
                    let trackEventHandler = new IrisTrackEventHandler_1.IrisTrackEventHandler(param, this._engine);
                    this._engine.irisClientManager.addTrackEventHandler(trackEventHandler);
                }).catch((e) => {
                    // P1.7: errore subscribe audio — remote resta muto senza feedback.
                    util_1.AgoraConsole.error(`subscribe audio failed for uid=${userPackage.uid}: ${e}`);
                });
            }
        });
    }
    unsubscribeVideoTrack(userPackage, force) {
        return __awaiter(this, void 0, void 0, function* () {
            // AUDIT-v18: early-return se userPackage è null/undefined (può accadere da
            // onEventUserLeft con pkg già rimosso).
            if (!userPackage)
                return;
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(userPackage.connection);
            if (!(irisClient === null || irisClient === void 0 ? void 0 : irisClient.agoraRTCClient))
                return;
            let user = irisClient.agoraRTCClient.remoteUsers.find((item) => (0, util_1.getUidFromRemoteUser)(item) === userPackage.uid);
            if (!user || !user.videoTrack) {
                return;
            }
            yield irisClient.agoraRTCClient
                .unsubscribe(user, 'video')
                .then(() => {
                util_1.AgoraConsole.debug('onEventUserPublished unsubscribe video success');
                this._engine.irisClientManager.removetrackEventHandlerByRemoteUser(user, 'video');
            })
                .catch((e) => {
                // AUDIT-v18: unhandled rejection. unsubscribe throw se remote non
                // sottoscritto (race) — log ma non propagare.
                util_1.AgoraConsole.warn(`unsubscribe video failed for uid=${userPackage.uid}: ${e}`);
            });
        });
    }
    unsubscribeAudioTrack(userPackage, force) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!userPackage)
                return;
            let irisClient = this._engine.irisClientManager.getIrisClientByConnection(userPackage.connection);
            if (!(irisClient === null || irisClient === void 0 ? void 0 : irisClient.agoraRTCClient))
                return;
            let user = irisClient.agoraRTCClient.remoteUsers.find((item) => (0, util_1.getUidFromRemoteUser)(item) === userPackage.uid);
            if (!user || !user.audioTrack) {
                return;
            }
            yield irisClient.agoraRTCClient
                .unsubscribe(user, 'audio')
                .then(() => {
                util_1.AgoraConsole.debug('onEventUserPublished unsubscribe audio success');
                this._engine.irisClientManager.removetrackEventHandlerByRemoteUser(user, 'audio');
            })
                .catch((e) => {
                util_1.AgoraConsole.warn(`unsubscribe audio failed for uid=${userPackage.uid}: ${e}`);
            });
        });
    }
    notifyRemote(type_1, scopePackages_1) {
        return __awaiter(this, arguments, void 0, function* (type, scopePackages, force = true) {
            for (let scopePackage of scopePackages) {
                switch (type) {
                    case NotifyRemoteType.SUBSCRIBE_VIDEO_TRACK:
                        if (scopePackage) {
                            yield this.subscribeVideoTrack(scopePackage, force);
                        }
                        break;
                    case NotifyRemoteType.SUBSCRIBE_AUDIO_TRACK:
                        if (scopePackage) {
                            yield this.subscribeAudioTrack(scopePackage, force);
                        }
                        break;
                    case NotifyRemoteType.UNSUBSCRIBE_AUDIO_TRACK:
                        if (scopePackage) {
                            yield this.unsubscribeAudioTrack(scopePackage, force);
                        }
                        break;
                    case NotifyRemoteType.UNSUBSCRIBE_VIDEO_TRACK:
                        if (scopePackage) {
                            yield this.unsubscribeVideoTrack(scopePackage, force);
                        }
                        break;
                }
            }
        });
    }
    release() {
        this.audioTrackPackageObservers = [];
        this.videoTrackPackageObservers = [];
        this.remoteUserPackageObservers = [];
    }
}
exports.IrisClientObserver = IrisClientObserver;
